/**
 * Converse status SSE API (feat-80).
 *
 * Opens a dedicated turn-status stream (not the multiplexed notification hub).
 * Auth is a bearer Authorization header via the shared fetch-SSE client.
 */

import { bffEventStream } from '../../../common/services/httpClient';
import type { SseSubscription } from '../../../common/services/fetchSse';
import { ESA_API_PATHS } from '../../../constants/apiPaths';

export interface OpenConverseStatusStreamOptions {
  afterSeq?: number;
}

/**
 * Open SSE for mid-turn converse status on a conversation.
 * Path: GET /conversations/{id}/status/stream
 */
export function openConverseStatusStream(
  conversationId: string,
  options?: OpenConverseStatusStreamOptions,
): SseSubscription {
  const path = ESA_API_PATHS.conversationStatusStream(conversationId, options?.afterSeq);
  return bffEventStream(path);
}
